import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'ReviewPage',
        path: () => path.join(__dirname, './ReviewPage'),
        resolve: () => require.resolveWeak('./ReviewPage'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "ReviewPage" */ './ReviewPage')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        timeout,
    }
);
